export {
  UTM_DEFAULT_SOURCE,
  UTM_DEFAULT_MEDIUM,
  urlSinUtmsPrincipales,
  getUtmParams,
  saveUtmParams,
  getCurrentUrlWithUtmDefaults,
  buildUtmQueryString,
} from "../utils/utmParams";

// Configuración de números de WhatsApp por UTM parameters
export const whatsappConfig = {
  // Número por defecto (original)
  default: {
    // Solo dígitos con código país (ej. AR): 54 + 9 + área + número
    number: "5493517915736",
    message: "Hola Montironi GAC!",
  },
};

export const buildWhatsAppUrl = (message) => {
  const defaultConfig = whatsappConfig.default;
  const encodedMessage = encodeURIComponent(message ?? defaultConfig.message);
  return `https://wa.me/${defaultConfig.number}?text=${encodedMessage}`;
};

// Función para obtener la URL de WhatsApp (compatible con uso actual)
export const getWhatsAppUrl = (utmParams = {}) => {
  return buildWhatsAppUrl();
};
